// SPDX-License-Identifier: Apache-2.0

// /chat (and / by default) — the actual product surface.
//
// VaultExperience replaces the old hero card. Apollo+Hermes will graft a chat
// side-panel on the right rail in their stream; we leave the right side
// untouched so their absolute-positioned panel can slot in without fighting
// for layout space.
//
// `?room=<id>` URL param wires Iris 3's collab-presence layer. Two browser
// tabs at the same room see each other's avatars in the topbar.

import { useSearchParams } from "@solidjs/router";
import VaultExperience from "../components/vault/VaultExperience";

export default function Chat() {
  const [searchParams] = useSearchParams();
  const roomId = () => {
    const r = searchParams.room;
    if (typeof r === "string" && r.length > 0 && r.length <= 128) return r;
    return undefined;
  };
  return (
    <section data-vault-route style={{ position: "relative", height: "100%" }}>
      <VaultExperience roomId={roomId()} />
    </section>
  );
}
